<template>
    <span>
        {{ formattedDate }}
    </span>
</template>

<script setup>
    const props = defineProps({
        date: String,
        end: String,
        displaySameDay: {
            type: Boolean,
            default: true,
        },
        format: {
            type: String,
            default: 'lll',
        },
        locale: {
            type: String,
            default: 'en-au',
        },
        fromNow: {
            type: Boolean,
            default: false,
        },
    })

    const dayjs = useDayjs()

    dayjs.locale(props.locale)

    const formattedDate = computed(() => {
        if (!props.date) {
            return ''
        }

        // Extract timezone from the date string if present (e.g., +11:00)
        const tzMatch = props.date?.match(/([+-]\d{2}:\d{2})$/)
        const hasTimezone = tzMatch && tzMatch[1]

        // If the date has timezone info, parse it and keep that timezone
        // Otherwise parse normally
        const startDate = hasTimezone ? dayjs(props.date).utcOffset(tzMatch[1]) : dayjs(props.date)

        if (!startDate.isValid()) {
            return ''
        }

        let endDate = null

        if (props.fromNow) {
            return startDate.fromNow()
        }

        if (props.end) {
            const endTzMatch = props.end?.match(/([+-]\d{2}:\d{2})$/)
            const endHasTimezone = endTzMatch && endTzMatch[1]
            endDate = endHasTimezone ? dayjs(props.end).utcOffset(endTzMatch[1]) : dayjs(props.end)
        }

        if (endDate && endDate.isValid()) {
            if (startDate.isSame(endDate, 'day') && props.displaySameDay) {
                return `${startDate.format(props.format)} - ${endDate.format('LT')}`
            }

            if (startDate.isSame(endDate, 'day') && !props.displaySameDay) {
                return `${startDate.format(props.format)}`
            }

            return `${dayjs(props.date).format(props.format)} - ${dayjs(props.end).format(props.format)}`
        }
        return startDate.format(props.format)
    })
</script>
